/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FilterCriteriaInfo,
  ReferentialItemDto,
  UsersServicesLiesDto,
  UsersServicesLiesGridDtoPaginatedResults,
  UsersServicesLiesSearchDto,
} from '../models/index';
import {
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoToJSON,
    UsersServicesLiesDtoFromJSON,
    UsersServicesLiesDtoToJSON,
    UsersServicesLiesGridDtoPaginatedResultsFromJSON,
    UsersServicesLiesGridDtoPaginatedResultsToJSON,
    UsersServicesLiesSearchDtoFromJSON,
    UsersServicesLiesSearchDtoToJSON,
} from '../models/index';

export interface UsersServicesLiesBaseSearchRequest {
    UsersServicesLiesSearchDto?: UsersServicesLiesSearchDto;
}

export interface UsersServicesLiesGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface UsersServicesLiesGetSelectItemsRequest {
    searchField: string;
}

export interface UsersServicesLiesGetUserServicesRequest {
    idUser?: number;
}

export interface UsersServicesLiesSaveServicesRequest {
    UsersServicesLiesDto?: UsersServicesLiesDto;
}

/**
 * 
 */
export class UsersServicesLiesApi extends runtime.BaseAPI {

    /**
     */
    async usersServicesLiesBaseSearchRaw(requestParameters: UsersServicesLiesBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersServicesLiesGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersServicesLies/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UsersServicesLiesSearchDtoToJSON(requestParameters.UsersServicesLiesSearchDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersServicesLiesGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async usersServicesLiesBaseSearch(requestParameters: UsersServicesLiesBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersServicesLiesGridDtoPaginatedResults> {
        const response = await this.usersServicesLiesBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersServicesLiesGetSearchCriteriasRaw(requestParameters: UsersServicesLiesGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersServicesLies/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async usersServicesLiesGetSearchCriterias(requestParameters: UsersServicesLiesGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.usersServicesLiesGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersServicesLiesGetSelectItemsRaw(requestParameters: UsersServicesLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling usersServicesLiesGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersServicesLies/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     */
    async usersServicesLiesGetSelectItems(requestParameters: UsersServicesLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.usersServicesLiesGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersServicesLiesGetUserServicesRaw(requestParameters: UsersServicesLiesGetUserServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersServicesLiesDto>> {
        const queryParameters: any = {};

        if (requestParameters.idUser !== undefined) {
            queryParameters['idUser'] = requestParameters.idUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersServicesLies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersServicesLiesDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersServicesLiesGetUserServices(requestParameters: UsersServicesLiesGetUserServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersServicesLiesDto> {
        const response = await this.usersServicesLiesGetUserServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersServicesLiesSaveServicesRaw(requestParameters: UsersServicesLiesSaveServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersServicesLiesDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/UsersServicesLies/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UsersServicesLiesDtoToJSON(requestParameters.UsersServicesLiesDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersServicesLiesDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersServicesLiesSaveServices(requestParameters: UsersServicesLiesSaveServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersServicesLiesDto> {
        const response = await this.usersServicesLiesSaveServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
